<carousel>
    <slide *ngFor="let slider of sliders">
      <img src="{{slider.image}}" alt="first slide" style="display: block; width: 100%;">
    </slide>
   
  </carousel>